/** Presentation helpers shared by the API (labels, exports) and the web app. */
const COMPACT = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 2 });
export function formatCompact(n) {
    if (n === undefined || n === null || !Number.isFinite(n))
        return '—';
    if (n === 0)
        return '0';
    if (Math.abs(n) < 0.0001)
        return n.toExponential(2);
    return COMPACT.format(n);
}
export function formatUsd(n) {
    if (n === undefined || n === null || !Number.isFinite(n))
        return '—';
    if (Math.abs(n) >= 1000)
        return `$${COMPACT.format(n)}`;
    if (Math.abs(n) >= 1)
        return `$${n.toFixed(2)}`;
    if (n === 0)
        return '$0';
    return `$${n.toPrecision(3)}`;
}
export function formatPercent(n, digits = 2) {
    if (n === undefined || n === null || !Number.isFinite(n))
        return '—';
    if (n > 0 && n < 0.01)
        return '<0.01%';
    return `${n.toFixed(digits)}%`;
}
export function shortAddress(address, head = 6, tail = 4) {
    if (!address)
        return '';
    if (address.length <= head + tail + 2)
        return address;
    return `${address.slice(0, head)}…${address.slice(-tail)}`;
}
export function formatAge(fromUnixSeconds, now = Date.now() / 1000) {
    if (!fromUnixSeconds)
        return '—';
    const s = Math.max(0, now - fromUnixSeconds);
    const units = [
        [60 * 60 * 24 * 365, 'y'],
        [60 * 60 * 24 * 30, 'mo'],
        [60 * 60 * 24, 'd'],
        [60 * 60, 'h'],
        [60, 'm'],
    ];
    for (const [secs, label] of units) {
        if (s >= secs)
            return `${Math.floor(s / secs)}${label}`;
    }
    return `${Math.floor(s)}s`;
}
export function formatDuration(seconds) {
    if (!Number.isFinite(seconds))
        return '—';
    if (seconds < 60)
        return `${Math.round(seconds)}s`;
    if (seconds < 3600)
        return `${Math.round(seconds / 60)}m`;
    if (seconds < 86400)
        return `${(seconds / 3600).toFixed(1)}h`;
    return `${(seconds / 86400).toFixed(1)}d`;
}
/** Deterministic palette used for clusters — distinct hues, dark-UI friendly. */
/**
 * Vivid hues that read on deep navy and stay clear of the UI's own blue
 * accent (no greens: green reads as "safe") and the green/red reserved for buys and sells.
 */
export const CLUSTER_PALETTE = [
    '#ff5c8a',
    '#f5b13d',
    '#22d3ee',
    '#c084fc',
    '#e2e8f0',
    '#fb923c',
    '#a5b4fc',
    '#f472b6',
    '#facc15',
    '#818cf8',
    '#e879f9',
    '#38bdf8',
    '#fda4af',
    '#ffd6a5',
    '#fdba74',
];
/** Colour for the n-th trader group (0-based). */
export const groupColor = (index) => CLUSTER_PALETTE[((index % CLUSTER_PALETTE.length) + CLUSTER_PALETTE.length) % CLUSTER_PALETTE.length];
export const clusterColor = (rank) => CLUSTER_PALETTE[(rank - 1 + CLUSTER_PALETTE.length) % CLUSTER_PALETTE.length];
export function gradeColor(grade) {
    switch (grade) {
        case 'excellent':
            return '#34d399';
        case 'good':
            return '#84cc16';
        case 'fair':
            return '#facc15';
        case 'poor':
            return '#ff9f45';
        default:
            return '#ff5c5c';
    }
}
export function riskColor(level) {
    switch (level) {
        case 'low':
            return '#5ef38c';
        case 'medium':
            return '#ffd166';
        case 'high':
            return '#ff9f45';
        default:
            return '#ff4d4d';
    }
}
//# sourceMappingURL=format.js.map